/**
 *
 * Caption
 *
 */

import { Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import styles from './styles';

/**
 *  @deprecated
 *  @example
 *
 *  Use `Typography` from `@material-ui/core` instead.
 *
 *  ```
 *  <Typography variant="caption" />
 *  ```
 */
function Caption({
  classes,
  children,
  // eslint-disable-next-line no-unused-vars
  color,
  align,
  component,
  display,
  gutterBottom,
  id,
  noWrap,
  paragraph,
  to,
}) {
  const { root } = classes;
  return (
    <Typography
      align={align}
      classes={classes}
      className={root}
      component={component}
      display={display}
      gutterBottom={gutterBottom}
      id={id}
      noWrap={noWrap}
      paragraph={paragraph}
      to={to}
      variant="caption"
    >
      {children}
    </Typography>
  );
}

Caption.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
  // color prop is passed into styles.js
  // it is undefined if nothing is passed into it, not default prop
  color: PropTypes.string,

  component: PropTypes.elementType,

  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  gutterBottom: PropTypes.bool,

  id: PropTypes.string,

  noWrap: PropTypes.bool,

  paragraph: PropTypes.bool,
  to: PropTypes.string,
};

Caption.defaultProps = {
  align: 'inherit',
  // default color prop only for convention, does not affect style
  color: 'gray600',

  display: 'initial',

  gutterBottom: false,

  noWrap: false,

  paragraph: false,
  to: '',
};

export default withStyles(styles)(memo(Caption));
